export const FIRST_NAMES = [
    'Kathleen',
    'Danielle',
    'Pamela',
    'Joyce',
    'Adam',
    'Tina',
    'Melissa',
    'David',
    'Kristen',
    'John',
    'Mary',
    'Virginia',
    'Phyllis',
    'Jimmie',
    'Wesley',
    'Kris',
    'Andrea',
    'Kathryn',
    'Paul',
    'Gerry',
    'Mark',
    'Dorothy',
    'James',
    'Alicia',
    'Kenneth',
    'Tristan',
    'Marc',
    'Ryan',
    'Harold',
    'Justin',
    'Charlie',
    'Kelly',
    'Janet',
    'Charles',
    'Carlos',
    'Ronald',
    'Kim',
    'Trina',
    'Joel',
    'Elizabeth',
    'Margaret',
    'Michael',
    'Edward',
    'Jamie',
    'Isaac',
    'Robert',
    'Yvette',
    'Shameka',
    'Thomas',
    'Willie',
    'Esther',
    'Victoria',
    'Troy',
    'Rosella',
    'Selma',
    'Catherine',
    'Conrad',
    'Clifford',
    'Lisa',
    'Donte',
    'Elmer',
    'Brian',
    'April',
    'Joshua',
    'Jessica',
    'Ernesto',
    'Constance',
    'Gerald',
    'Gail',
    'Gaynell',
    'Oscar',
    'Steven',
    'Paula',
    'Ernestine',
    'Billy',
    'Virgilio',
    'Kaye',
    'Pauline',
    'Eric',
    'Terrence',
    'Ronnie',
    'Lydia',
    'Maria',
    'Jason',
    'Beth',
    'Milton',
    'Christopher',
    'Maryjane',
    'Micheal',
    'Florence',
    'William',
    'Michele',
    'Norma',
    'Katherine',
    'Carmine',
    'Valene',
    'Lucille',
    'Valerie',
    'Kelsey',
    'Owen',
]